module.exports = __webpack_public_path__ + "static/integration/img/ally-icon-af-download-logo.f25b92cffd71eaede2d7d3f62c34299d.svg";